import React from 'react';
import { RequestQuote } from '@mui/icons-material';
import { useTranslation } from '@hooks/useTranslation';

interface EmptyBudgetStateProps {
  isDelegatedTask?: boolean;
  hasSubDelegation?: boolean;
  task?: any;
  message?: string;
}

export const EmptyBudgetState: React.FC<EmptyBudgetStateProps> = ({
  isDelegatedTask = false,
  hasSubDelegation = false,
  task,
  message,
}) => {
  const tTaskDetail = useTranslation('taskDetail');

  if (message) {
    return (
      <div className="text-center py-8">
        <div className="bg-gray-50 rounded-lg p-6">
          <RequestQuote className="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            {tTaskDetail.budget.noBidActivityTitle}
          </h3>
          <p className="text-gray-500">{message}</p>
        </div>
      </div>
    );
  }

  if (hasSubDelegation) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg">
        <div className="p-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">
            {!isDelegatedTask
              ? tTaskDetail.budget.delegationBidDetailsTitle
              : tTaskDetail.budget.subDelegationBidDetailsTitle}
          </h3>
        </div>
        <div className="p-8 text-center">
          <RequestQuote className="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            {tTaskDetail.budget.noBidRequestFoundTitle}
          </h3>
          <p className="text-gray-500 mb-2">
            {tTaskDetail.budget.delegatedNoBidRequestMessage}
          </p>
          <p className="text-sm text-gray-400">
            {tTaskDetail.budget.taskDelegatedTo}{' '}
            {task?.delegateOrganization?.name || tTaskDetail.budget.unknownOrganization}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center py-8">
      <div className="bg-gray-50 rounded-lg p-6">
        <RequestQuote className="mx-auto h-12 w-12 text-gray-400 mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {tTaskDetail.budget.noBudgetActivityTitle}
        </h3>
        <p className="text-gray-500">{tTaskDetail.budget.noBudgetActivityMessage}</p>
      </div>
    </div>
  );
};